import React from "react";
import { Route } from "react-router-dom";

import ApplicationDetails from "cortex/ui/src/fleet/view/application/component/ApplicationDetails";
import ApplicationInstalledList from "cortex/ui/src/fleet/view/application/component/ApplicationInstalledList";
import ApplicationStoreList from "cortex/ui/src/fleet/view/application/component/ApplicationStoreList";
import UploadPage from "cortex/ui/src/fleet/view/application/component/UploadApplication";

function renderApplicationsRoutes() {
  return [
    <Route
      component={ApplicationInstalledList}
      exact
      key="applications-list"
      path="/applications"
    />,
    <Route
      component={UploadPage}
      exact
      key="applications-upload"
      path="/applications/upload"
    />,
    <Route
      component={ApplicationStoreList}
      exact
      key="applications-store"
      path="/applications/store"
    />,
    <Route
      component={ApplicationDetails}
      exact
      key="applications-details"
      path={["/applications/:id", "/applications/:id/:mode(testing)"]}
    />,
  ];
}

export { renderApplicationsRoutes };
